import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
    getValue<T>(key: string): T | null {
        return sessionStorage.getItem(key) as unknown as T | null;
    }

    getValues<T>(key: string): T[] {
        const value = sessionStorage.getItem(key);
        if (!value) return [];

        return value.split(',').map((item) => {
            if (typeof ({} as T) === 'number') {
                return Number(item) as T;
            }

            return item as unknown as T;
        });
    }

    setValue(key: string, value: string): void {
        sessionStorage.setItem(key, value);
    }
}
